import { audio } from '../systems/audio/AudioSystem.js';

/**
 * The opening of a standalone act — Act II and Act III both, since the two were
 * split apart (data/acts.js). Each is entered from the menu, so without a
 * screen of its own its prologue would never be read at all; Act II's used to
 * arrive mid-run on the descent interstitial, back when the King's fall was
 * literally its doorway. The copy lives in ACT_OPENINGS (data/lore.js).
 *
 * A held pause with a single button that resumes into the first wave stage —
 * the same shape FinalWarningOverlay uses.
 */
export class ActOpeningOverlay {
  constructor(eventBus, root, { onContinue }) {
    this.root = root;
    this.onContinue = onContinue;
    this.el = null;
    eventBus.on('act:opening', ({ tagline, prose, name, action }) => this._show({ tagline, prose, name, action }));
    // A run can be torn down before the player clicks through (returning to the
    // menu from the pause screen), so the overlay must not outlive it.
    eventBus.on('run:ended', () => this._hide());
  }

  _show({ tagline, prose, name, action }) {
    this._hide();
    const el = document.createElement('div');
    el.className = 'menu-overlay final-warning-overlay descent-overlay';
    el.innerHTML = `
      <div class="final-warning-tagline"></div>
      <div class="runend-epilogue"></div>
      <div class="final-warning-name"></div>
    `;
    // textContent rather than interpolation: this is prose with apostrophes and
    // em dashes in it, and there is no reason for any of it to be parsed.
    el.querySelector('.final-warning-tagline').textContent = tagline;
    el.querySelector('.runend-epilogue').textContent = prose;
    el.querySelector('.final-warning-name').textContent = name;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'menu-button menu-button-primary';
    button.textContent = action;
    button.addEventListener('click', () => {
      audio.playSfx('click');
      this._hide();
      this.onContinue();
    });
    el.appendChild(button);
    this.root.appendChild(el);
    this.el = el;
  }

  _hide() {
    this.el?.remove();
    this.el = null;
  }
}
